<div class="flex flex-col w-full" aria-busy="true">
  <div class="flex justify-between items-center mb-2">
    <span class="text-[18px] font-semibold text-primary-purple-light">{{ titleText() }}…</span>
    <span class="text-[18px] font-semibold text-primary-purple-light">{{ percentage() }}%</span>
  </div>
  <progress class="progress text-primary-purple-light w-full" [value]="percentage()" max="100" [attr.aria-label]="titleText()"></progress>
  <p class="mt-2 min-h-6 text-base font-normal text-center break-words" aria-live="polite">{{ detail() }}</p>
</div>
